import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/telkosh-logo.png";

const Navbar = () => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    navigate("/");
  };

  return (
    <div className="bg-white shadow-md p-3 flex items-center justify-between fixed top-0 left-0 w-full z-50 px-5">
      {/* Left: Teloksh Logo */}
      <div className="flex items-center">
        <img src={logo} alt="Teloksh Logo" className="h-10" />
      </div>

      {/* Center: Dashboard Heading */}
      <h2 className="text-2xl font-semibold">LMS Dashboard</h2>


      {/* Right: Profile Section */}
      <div className="relative">
        <img
          src="https://i.pravatar.cc/150?img=3"
          alt="Profile"
          className="w-10 h-10 rounded-full border-2 border-gray-300 cursor-pointer"
          onClick={() => setShowDropdown(!showDropdown)}
        />

        {/* Dropdown Menu */}
        {showDropdown && (
          <div className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-32">
            <button
              onClick={handleLogout}
              className="block w-full px-4 py-2 text-left text-red-600 hover:bg-gray-100"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
